import { PinInput, Text } from '@mantine/core';

function CustomPinInput({ error, ...rest }: any) {
  return (
    <div>
      <PinInput type="number" inputType="tel" inputMode="numeric" {...rest} />
      {error && <Text color="red" size="sm" mt={5}>{error}</Text>}
    </div>
  );
}

export default CustomPinInput;
